import { Module } from "@nestjs/common";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { TypeOrmModule } from '@nestjs/typeorm';
import { LogsService } from "@gtpl/shared-services/user-logs";
import { WhatsappBroadCastService } from "@gtpl/shared-services/whatsapp-broad-cast";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import { AdjustmentNoteController } from "./adjustmnet-notes.controller";
import { AdjustmentNotesService } from "./adjustment.service";
import { AdjustmentNotesEntity } from "./entity/adjustment-note.entity";
import { AdjustmentNoteRepository } from "./repository/adjustment-note-repo";

@Module({
    imports: [
      TypeOrmModule.forFeature([
        AdjustmentNotesEntity,
        AdjustmentNoteRepository
      ])
    ],
    controllers: [AdjustmentNoteController],
    providers: [ApplicationExceptionHandler,AdjustmentNotesService,LogsService,WhatsappBroadCastService,WhatsAppNotificationService],
  })
  export class AdjustmentNoteModule { }